import { Comment, List as ListIcon } from "@mui/icons-material";
import { Grid, IconButton } from "@mui/material";
import type { ICellRendererParams } from "ag-grid-community";
import type { MouseEvent } from "react";
import type { StrandLossByShift } from "../../models/StrandLossByShift";

interface GridButtonsProps {
  params: ICellRendererParams<StrandLossByShift>;
  justifyData: (data: StrandLossByShift) => void;
  showContextMenu: (event: MouseEvent<HTMLButtonElement>) => void;
}

export const GridButtons = ({
  params,
  justifyData,
  showContextMenu,
}: GridButtonsProps) => (
  <Grid
    container
    className="ag-grid-buttons"
    sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
  >
    <Grid
      item
      xs={12}
      md={12}
      sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    >
      <IconButton
        aria-label="Justify Strand Loss"
        title="Justify Strand Loss"
        sx={{ cursor: "pointer" }}
        onClick={() => params.data && justifyData(params.data)}
      >
        <Comment fontSize="inherit" color="primary" />
      </IconButton>
      <IconButton
        aria-label="Strand Loss options"
        title="Strand Loss options"
        sx={{ cursor: "pointer" }}
        onClick={showContextMenu}
      >
        <ListIcon fontSize="inherit" color="primary" />
      </IconButton>
    </Grid>
  </Grid>
);
